import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import InviteFriends from './InviteFriends';
import './CreateGroup.css';
import { createGroup as v2CreateGroup } from './v2Api';

const CreateGroup = ({ user }) => {
  const [groupName, setGroupName] = useState('');
  const [message, setMessage] = useState('');
  const [groupCreated, setGroupCreated] = useState(false);
  const [, setLinkKey] = useState('');

  const navigate = useNavigate();

  const handleCreateGroup = async () => {
    if (!groupName) {
      setMessage('Please enter a group name.');
      return;
    }

    try {
      const result = await v2CreateGroup(user, { name: groupName });
      setMessage(`Welcome to ${groupName}!`);
      setGroupName('');
      setGroupCreated(true);
      setLinkKey(result.link_key);
    } catch (error) {
      setMessage(`Error creating group: ${error.message}`);
    }
  };

  return (
    <div className="create-group">
      {!groupCreated && <h2>Create New Group</h2>}
      {!groupCreated && (
        <>
          <input
            type="text"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            placeholder="Enter group name"
          />
          <button className="active-button" onClick={handleCreateGroup}>Create New Group</button>
          {message && <p className="error-message">{message}</p>}
        </>
      )}
      {groupCreated && <h2>{message}</h2>}
      {groupCreated && (
        <div className="group-actions">
          <button className="active-button" onClick={() => navigate('/options')}>Explore events</button>
          <InviteFriends user={user} active={false} />
        </div>
      )}
    </div>
  );
};

export default CreateGroup;
